<div>

    <div class="col-md-12 no-padding">
        <div class="container">
            <div class="row">
                <div class="col">
                    <h4>Obavještenja</h4>
                </div>
                <div class="col">
                    <button class="col-md-12 pull-right btn btn-light btn-sm" (click)="getLiveViewItems()"
                            style="float: right;"><i
                            class="fa fa-retweet"></i>
                        Ažuriraj
                    </button>
                </div>
            </div>

        </div>


        <div class="col-md-12 no-padding" [ngStyle]="{'height': liveItems.length > 5 ? '400px':'200px'}">
            <ng-scrollbar #scrollable
                          [disableOnBreakpoints]="false">
                <div style="    padding-right: 12px;">
                    <ul class="list-group list-group-flush" *ngFor="let live of liveItems">
                        <li
                                class="list-group-item wb-live-list"
                                [ngStyle]="{'display': live.visibility==false?'none':'auto' }"
                                >
                            <div class="media">
                                <app-avatar [avatarWidth]="30" [assigned]="assign"
                                            *ngFor="let assign of live.assigned"></app-avatar>
                                <div class="media-body ml-2">
                                    <div (click)="navigateTo(live.task_id);closeNotification(live._id);"
                                         class="wd-task-timeline-title mb-0 ml-0"
                                         style="font-weight: 600;width: 100%;cursor: pointer">

                                        <a (click)="closeNotification(live._id);" style="color: black"
                                           [routerLink]="['/view-task',live.task_id]">
                                            {{live.taskData.title}}</a>
                                    </div>
                                    <button (click)="closeNotification(live._id);live.visibility=false" type="button"
                                            class="close"
                                            aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                    <p style="width:80%">{{live.description}}</p>

                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </ng-scrollbar>
        </div>
    </div>

    <div class="clearfix"></div>
    <div class="mt-4">
        <tabset>
            <tab>
                <ng-template tabHeading>
                    <i class="fa fa-users" title="Sastanci"></i> Sastanci
                </ng-template>

                <h4 class="col-md-10">Pregled sastanaka iz kalendara</h4>
                <div class="well-done-notification-block row">
                    <div class="wd-notif-blc-label meeting col-md-4">
                        <h5>Naredna 3 dana</h5>
                    </div>
                    <div class="wd-notif-blc-sep-label
col-md-3">
                        {{tomorrowMeetings.length}} {{tomorrowMeetings.length == 1 ? 'sastanak' : tomorrowMeetings.length > 1 && tomorrowMeetings.length < 5 ? 'sastanka' : 'sastanaka' }}
                    </div>

                    <div class="wd-notif-blc-item" *ngFor="let _meet of tomorrowMeetings">
                        <div class="wd-notif-blc-tasks col-md-12">
                            <div [routerLink]="['/view-task/'+ _meet._id]"
                                 class="wd-task-list-title no-padding col-md-10 text-left cursor ">
<span
        class="badge badge-secondary mr-1">{{_meet.meeting_time.start | date: 'dd.MM.YYYY. HH:mm'}}
    h</span>
                                <div class="wd-task-color-badge meeting"></div>
                                <span>{{_meet.title}}</span>
                            </div>
                            <div class="col-md-2 text-right no-padding mt-1">
                                <i class="fa fa-calendar-alt mr-2"></i>
                                <i class="fa fa-map-marked-alt"></i>
                            </div>
                            <div class=" no-padding col-md-2 text-right ">
                                <app-avatar [avatarWidth]="30"></app-avatar>
                            </div>

                        </div>
                    </div>
                </div>

            </tab>
            <tab>
                <ng-template tabHeading>
                    <i class="fa fa-calendar-check" title="podsetnik"></i> Bilješke
                </ng-template>
                <h4 class="col-md-6">Pregled beleški</h4>
                <div class="well-done-notification-block row">

                    <div class="wd-notif-blc-label note text-secondary col-md-4">
                        <h5>Sve bilješke</h5>
                    </div>
                    <div class="wd-notif-blc-sep-label  col-md-3">
                        {{allNotes.length}} {{allNotes.length == 1 ? 'bilješka' : allNotes.length > 1 && allNotes.length < 5 ? 'bilješke' : 'bilješki' }}
                    </div>

                    <div class="wd-notif-blc-item" *ngFor="let _note of allNotes">
                        <div class="wd-notif-blc-tasks col-md-12">
                            <div [routerLink]="['/view-task/'+ _note._id]"
                                 class="wd-task-list-title no-padding col-md-10 text-left cursor">

                                <div class="wd-task-color-badge meeting"></div>
                                <span>{{_note.title}}</span>
                            </div>

                        </div>
                    </div>

                </div>
            </tab>
            <tab>
                <ng-template tabHeading>
                    <i class="fa fa-notes-medical" title="Zabeleške"></i> Podsjetnici
                </ng-template>
                <h4 class="col-md-6">Pregled podsjetnika</h4>
                <div class="well-done-notification-block row">

                    <div class="wd-notif-blc-label reminder col-md-4">
                        <h5>Narednih 10 dana</h5>
                    </div>
                    <div class="wd-notif-blc-sep-label   col-md-3">
                        {{allReminders.length}} {{allNotes.length == 1 ? 'podsjetnik' : 'podsjetnika' }}
                    </div>

                    <div class="wd-notif-blc-item" *ngFor="let _reminder of allReminders">
                        <div class="wd-notif-blc-tasks col-md-12">
                            <div [routerLink]="['/view-task/'+ _reminder._id]"
                                 class="wd-task-list-title no-padding col-md-10 text-left cursor">
<span
        class="badge badge-secondary mr-1">{{_reminder.reminder_time.start | date: 'dd.MM.yyyy. HH:mm'}}
    h</span>
                                <div class="wd-task-color-badge meeting"></div>
                                <span>{{_reminder.title}}</span>
                            </div>
                            <div class="col-md-2 float-right no-padding mt-1">
                                <i class="fa fa-calendar-alt mr-2"></i>
                                <i class="fa fa-map-marked-alt"></i>
                            </div>
                        </div>
                    </div>

                </div>
            </tab>


        </tabset>
    </div>
</div>



